import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import InputView from './InputView';
import MultiScenarioView from './MultiScenarioView';
import { useTheme } from '@mui/material/styles';

interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

interface ModelingProps {
  title?: string;
}

function Modeling({ title = "Modeling" }: ModelingProps) {
  const [value, setValue] = useState(0);
  const theme = useTheme();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ 
      width: '100%',
      background: theme.palette.background.default,
      color: theme.palette.text.primary
    }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="modeling tabs">
          <Tab label="Input (Current)" />
          <Tab label="Multi-Scenario" />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <InputView />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <MultiScenarioView />
      </TabPanel>
    </Box>
  );
}

export default Modeling; 